// removed by extract-text-webpack-plugin
module.exports = {"content":"vj4rkKO43YyiwhJgJOQX5","saveButton":"XdX9OY-wFwUAorgV1QsB9","message":"_21Amo2dK9ErKmHw6MWOI7k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/SelectModelForm.css
// module id = 881
// module chunks = 0